/**
 * Generate social media share URLs
 */
export const getSocialShareUrl = (platform, { url, text, title }) => {
    const encodedUrl = encodeURIComponent(url || '');
    const encodedText = encodeURIComponent(text || '');
    const encodedTitle = encodeURIComponent(title || '');

    const socialLinks = {
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
        telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
        email: `mailto:?subject=${encodedTitle}&body=${encodedText}%20${encodedUrl}`,
    };

    return socialLinks[platform] || null;
};

/**
 * Open social media share link
 */
export const openSocialShare = (platform, shareData) => {
    const url = getSocialShareUrl(platform, shareData);
    if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
        return true;
    }
    return false;
};

